//@flow
import * as Immutable from 'immutable';
import {
    validatable,
    validate,
    validateAll
} from 'common/utils/ValidationUtil';
import DataUtils from 'common/utils/DataUtils';

import { VehicleTravelParams } from 'common/models/flow/VehicleTravelParams';
import type { VehicleTravelParamsModelType } from 'common/models/flow/VehicleTravelParams';
import NumberUtils from 'common/utils/NumberUtils';
import I18nHelper from 'common/helpers/I18nHelper';

const translationsNamespace = ['validations'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

@validatable
class InternalVehicleTravelParams extends VehicleTravelParams {
    static fromJS(
        json: VehicleTravelParamsModelType
    ): InternalVehicleTravelParams {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    @validate
    setMaxSpeed(maxSpeed: number): this {
        return super.setMaxSpeed(maxSpeed);
    }

    validateMaxSpeed(): ?string {
        if (
            !DataUtils.isEmpty(this.maxSpeed) &&
            !NumberUtils.isPositiveNumber(this.maxSpeed)
        ) {
            return nsTranslate(
                'vehicleModelValidationErrors.maxSpeedNotPositive'
            );
        }
    }

    defaultSanitize(): ?VehicleTravelParams {
        const { maxSpeed, trafficFactor } = this;
        if (DataUtils.isEmpty(maxSpeed) && DataUtils.isEmpty(trafficFactor)) {
            return null;
        }
        return this;
    }

    defaultInit(): VehicleTravelParams {
        VehicleTravelParams.fromJS({
            maxSpeed: null,
            trafficFactor: null
        });
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }
}

export { InternalVehicleTravelParams as VehicleTravelParams };
